import { createSelector } from 'reselect';
import { PRACTICE, QUESTIONS } from '../constants/assessmentItemType';

export const getSpellingContent = (state, pageType, questionIndex = 0) => {
    let content;
    switch (pageType) {
    case PRACTICE:
        content = state.practice;
        break;
    case QUESTIONS:
        content = state.questions;
        break;
    default:
        content = [{}];
    }
    return content[questionIndex];
};

export const getSpellingCorrectResponse = createSelector(
    [getSpellingContent],
    (content) => {
        if (content && content.correctResponse) {
            return content.correctResponse;
        }
        return {};
    },
);

export const getSpellingStimulus = createSelector(
    [getSpellingContent],
    (content) => {
        if (content && content.stimulus) {
            return content.stimulus;
        }
        return {};
    },
);

export const getSpellingQuestionItems = (state, questionIndex) => {
    if (questionIndex >= 0) {
        return state.questions[questionIndex];
    }
    return state.questions;
};

export const getSpellingFormId = (state) => state.formId;

export const getSpellingPossibleResponses = createSelector(
    [getSpellingContent],
    (content) => {
        if (content && content.possibleResponses) {
            return content.possibleResponses;
        }
        return [];
    },
);

export const getSpellingEnabledResponses = (state) => state.enabledResponses;

export const getIsSpellingReadyScriptPlayed = (state) => state.isReadyScriptPlayed;

export const getIsSpellingDataFetched = (state) => state.isDataFetched;

export const getSpellingTotalQuestions = (state) => {
    if (state.questions) {
        return state.questions.length;
    }
    return 0;
};

export const getIsButtonGridEnabled = (state) => state.isButtonGridEnabled;

export const getIsClearButtonEnabled = (state) => state.isClearButtonEnabled;
